import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DEVICE_INFO } from 'constants/deviceInfo'
import 'scss/5_components/_tabs.scss'

/* <TabContainer> Documentation
<TabContainer> Component
  - activeTabIndex: Index of the default tabs
<Tab> Component
  - label: The text to be displayed
  - count: A count number if it exists
  - postTabClick: A callback function when tab is clicked (useful for changing state)
*/

/** @deprecated */
export class TabContainer extends Component {
  constructor(props, context) {
    super(props, context)
    const { activeTabIndex } = this.props
    this.state = { activeTabIndex }
    this.handleTabClick = this.handleTabClick.bind(this)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ activeTabIndex: nextProps.activeTabIndex })
  }

  handleTabClick(tabIndex, postTabClick = () => {}) {
    this.setState({ activeTabIndex: tabIndex })
    postTabClick(tabIndex)
  }

  renderChildrenWithTabsApiAsProps() {
    const { children, dataTest } = this.props
    const { activeTabIndex } = this.state
    return React.Children.map(children, (child, index) =>
      React.cloneElement(child, {
        onClick: this.handleTabClick,
        tabIndex: index,
        dataTest,
        isActive: index === activeTabIndex,
      })
    )
  }

  renderActiveTabContent() {
    const { children } = this.props
    const { activeTabIndex } = this.state
    if (!children) return null
    if (children[activeTabIndex]) {
      return children[activeTabIndex].props.children
    }
    return children[0].props.children
  }

  render() {
    const { containerClass, dataTest } = this.props
    return (
      <div className='mb1'>
        {!DEVICE_INFO.isMobile && (
          <ul className='tabs' data-test={`${dataTest}-tab-container`}>
            {this.renderChildrenWithTabsApiAsProps()}
          </ul>
        )}
        {DEVICE_INFO.isMobile && (
          <select
            className='mb4'
            data-test={`${dataTest}-tab-container`}
            onChange={e => {
              e.preventDefault()
              const tabIndex = e.target.selectedIndex
              const { postTabClick } = this.props
              postTabClick(tabIndex)
            }}>
            {this.renderChildrenWithTabsApiAsProps()}
          </select>
        )}
        {this.renderActiveTabContent() && (
          <>
            <hr className='mv0' />
            <div className={containerClass}>{this.renderActiveTabContent()}</div>
          </>
        )}
      </div>
    )
  }
}

/** @deprecated */
export const Tab = props => {
  const { count, dataTest, isActive, label, onClick, postTabClick, tabIndex } = props
  const propCounts = <span className='tag tag-round tag-small'>{count}</span>
  return (
    <>
      {!DEVICE_INFO.isMobile && (
        <li className={`tab fl dn db-ns ${isActive ? 'active' : 'not-active'}`}>
          <button
            data-test={`${dataTest}-tab-${tabIndex}`}
            className='btn-text-link key'
            onClick={e => {
              e.preventDefault()
              onClick(tabIndex, postTabClick)
            }}>
            {label}
            {count ? propCounts : ''}
          </button>
        </li>
      )}
      {DEVICE_INFO.isMobile && (
        <option value={label}>
          {label} {count ? `: ${count} Results` : ''}
        </option>
      )}
    </>
  )
}

Tab.propTypes = {
  tabIndex: PropTypes.number,
  isActive: PropTypes.bool,
  count: PropTypes.number,
  label: PropTypes.string.isRequired,
  postTabClick: PropTypes.func,
  onClick: PropTypes.func,
  dataTest: PropTypes.string,
}

Tab.defaultProps = {
  tabIndex: 0,
  isActive: false,
  count: null,
  postTabClick: () => {},
  onClick: () => {},
  dataTest: 'tab',
}

TabContainer.propTypes = {
  activeTabIndex: PropTypes.number,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  containerClass: PropTypes.string,
  postTabClick: PropTypes.func,
  dataTest: PropTypes.string,
}

TabContainer.defaultProps = {
  activeTabIndex: 0,
  containerClass: null,
  postTabClick: () => {},
  dataTest: 'tab-container',
}
